import type { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StationSpacesUseCaseView } from './components/StationSpacesUseCaseView';
import type { SpacesUseCaseType } from '@utils/station';

const VALID_TYPES: SpacesUseCaseType[] = ['hospitality', 'retail', 'transit'];

const StationSpacesPage: FC = () => {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const useCaseType: SpacesUseCaseType =
    typeParam && VALID_TYPES.includes(typeParam as SpacesUseCaseType)
      ? (typeParam as SpacesUseCaseType)
      : 'hospitality';

  return <StationSpacesUseCaseView useCaseType={useCaseType} />;
};

export default StationSpacesPage;
